/**
 * Used to create a infinite scroll effect, where
 * more items are loaded in as the user scrolls.
 * Listens for scroll reaching the bottom of containerRef,
 * and calls fetchMore when this occurs if depleted is false.
 * Set depleted to true when there is nothing more to load.
 * Scroll handler is throttled.
 * TODO: allow loading at any distance from bottom
 */

import { useEffect } from 'react';
import { throttle } from 'lodash';

const THROTTLE_MS = 250;

const useInfiniteScroll = (
  nodeOrDocument: HTMLElement | Document | null,
  enabled: boolean,
  fetchMore: () => void,
  waitForScroll = true,
  scrollBuffer = 0,
): void => {
  useEffect(() => {
    if (!nodeOrDocument || !enabled) {
      return;
    }

    const handleScroll = throttle(() => {
      const node = isDocument(nodeOrDocument)
        ? document.documentElement
        : nodeOrDocument;
      const isBottom =
        node.scrollHeight - node.scrollTop <= node.clientHeight + scrollBuffer;
      if (isBottom) fetchMore();
    }, THROTTLE_MS);

    if (!waitForScroll) {
      fetchMore();
    }
    nodeOrDocument.addEventListener('scroll', handleScroll);
    return () => nodeOrDocument.removeEventListener('scroll', handleScroll);
    // NATIONAL PARKS: Please remove this disable and try to fix it if you're here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [nodeOrDocument, enabled, fetchMore]);
};

const isDocument = (u: unknown): u is Document => u === document;

export default useInfiniteScroll;
